import { render, staticRenderFns } from "./NotifList.vue?vue&type=template&id=5d1ee920&"
import script from "./NotifList.vue?vue&type=script&lang=js&"
export * from "./NotifList.vue?vue&type=script&lang=js&"
import style0 from "./NotifList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports